import SetMainPhoneButton from './SetMainPhoneButton';

export default SetMainPhoneButton;